// extracted by mini-css-extract-plugin
module.exports = {"categoriesContainer":"CategoriesWithTitles_categoriesContainer__3TjHq"};